import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Typography, Button, MenuItem, TextField } from "@mui/material";
import GoalVideoComponent from "./GoalVideoComponent";
import Position from "./leaderboardBanner/Position";
import { styled } from "@mui/material";
import moment from "moment";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import { useSelector } from "react-redux";

const CustomTextarea = styled(TextField)(() => ({
  flexGrow: "1",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    color: "#6f7081",
    padding: "0px 0px 0px 30px;",
    "&:hover": { backgroundColor: "transparent" },
    "&.Mui-focused": { backgroundColor: "transparent", outline: "none" },
  },
  "& .MuiInputBase-input": { padding: "0" },
  "& .MuiSelect-icon": { color: "#6f7081 !important" },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": { border: "none" },
  },
}));

const Leaderboard = ({
  goals,
  setTournamentData,
  club_logo,
  fetchLeaderboard,
  clubData,
}) => {
  const token = useSelector((state) => state.auth.token);
  const [filter, setFilter] = useState("yearly");
  const [month, setMonth] = useState(clubData?.clubEvents?.rows[0].id);
  const [year, setYear] = useState(new Date().getFullYear());

  // ── Two additions for banner particles ──
  const bannerRef = useRef(null);
  const [bannerHovered, setBannerHovered] = useState(false);

  useSkipFirstRender(() => {
    if (filter === "monthly") {
      if (!month) return;
      fetchLeaderboard(clubData.id, token, { year: null, month });
    } else if (filter === "yearly") {
      fetchLeaderboard(clubData.id, token, { year, month: null });
    }
  }, [filter]);

  useSkipFirstRender(() => {
    fetchLeaderboard(clubData.id, token, { year, month: null });
  }, [year]);

  useSkipFirstRender(() => {
    if (month) fetchLeaderboard(clubData.id, token, { year: null, month });
  }, [month]);

  return (
    <>
      <Box className={"filters"}>
        <Button
          className={
            filter === "monthly" ? "filter_item active" : "filter_item"
          }
          onClick={() => setFilter("monthly")}
        >
          Monthly
        </Button>
        <Button
          className={filter === "yearly" ? "filter_item active" : "filter_item"}
          onClick={() => setFilter("yearly")}
        >
          Seasons
        </Button>
      </Box>

      <Box
        className="Category-filter-wrapper"
        sx={{
          justifyContent: "space-between",
          minHeight: "70px",
          borderBottom: "1px solid #414466;",
        }}
      >
        {filter === "yearly" ? (
          <CustomTextarea
            select
            variant="outlined"
            name="previous_months"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            sx={{
              maxWidth: "200px",
              border: "1px solid #414466",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            <MenuItem value="default">Select Year</MenuItem>
            {Array.from({ length: 6 }).map((_, i) => (
              <MenuItem
                key={i}
                value={moment(clubData.createdAt)
                  .add(i, "years")
                  .format("YYYY")}
              >
                {moment(clubData.createdAt).add(i, "years").format("YYYY")}
              </MenuItem>
            ))}
          </CustomTextarea>
        ) : (
          <CustomTextarea
            select
            variant="outlined"
            name="previous_months"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            sx={{
              maxWidth: "200px",
              border: "1px solid #414466",
              borderRadius: "8px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            <MenuItem value="default">Select Months</MenuItem>
            {clubData?.clubEvents?.rows.length > 0 ? (
              clubData.clubEvents.rows.map((obj) => (
                <MenuItem key={obj.id} value={obj.id}>
                  {obj.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem>No club month found</MenuItem>
            )}
          </CustomTextarea>
        )}
      </Box>

      <Box className="leaderboard_wrapper club_leaderboard_wrapper">
        <Typography component="h1" className="title">
          Leaderboard
        </Typography>

        {goals?.length > 0 ? (
          <Box
            className="leaderboard-banner-wrapper"
            ref={bannerRef}
            onMouseEnter={() => setBannerHovered(true)}
            onMouseLeave={() => setBannerHovered(false)}
            sx={{ position: "relative", overflow: "hidden", cursor: "default" }}
          >
            <Box className="background">
              <Typography component={"span"} className="heading_text">
                TOP LEADERBOARD OF THE MONTH
              </Typography>
              <Box className="position-wrapper">
                <Position
                  index={0}
                  leaderboard={goals}
                  club_logo={club_logo}
                  bannerRef={bannerRef}
                  bannerHovered={bannerHovered}
                />
                {goals?.length > 1 && (
                  <Position
                    index={1}
                    leaderboard={goals}
                    club_logo={club_logo}
                    bannerRef={bannerRef}
                    bannerHovered={bannerHovered}
                  />
                )}
                {goals?.length > 2 && (
                  <Position
                    index={2}
                    leaderboard={goals}
                    club_logo={club_logo}
                    bannerRef={bannerRef}
                    bannerHovered={bannerHovered}
                  />
                )}
              </Box>
            </Box>
          </Box>
        ) : null}

        {Array.isArray(goals) && goals.length > 0 ? (
          <>
            <Box className="rank-logo">Rank</Box>
            {goals.map((ele, index) => (
              <GoalVideoComponent
                key={index}
                data={ele}
                setTournamentData={setTournamentData}
                index={index}
              />
            ))}
          </>
        ) : (
          <Box className="no-data-found">No Data Found</Box>
        )}
      </Box>
    </>
  );
};

export default Leaderboard;
